<template>
  <v-chip v-if="priority" :color="chipColor" small :outlined="!priority">
    <span class="blue-grey--text text--darken-3">{{
      $t(`rev.priority.${priority || 'none'}`)
    }}</span>
  </v-chip>
  <div v-else class="text-start">-</div>
</template>

<script>
export default {
  name: 'PriorityChips',

  props: {
    priority: {
      type: String,
      required: false,
    },
  },

  computed: {
    chipColor() {
      switch (this.priority) {
        case 'high':
          return 'red lighten-5 '
        case 'medium':
          return 'yellow lighten-5'
        case 'low':
          return 'blue lighten-5'
        default:
          return 'blue-grey lighten-5'
      }
    },
  },
}
</script>
